import React, { useState, useEffect } from "react";
import { Button, TextField, Box, Typography, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ShowAllServiceLocation } from "../../../../context/Slice/VendorManagementSlice";
import Select from "react-select";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = localStorage.getItem("token");

const VendorServicesEditForm = ({
  filteredVendor,
  selectedValues,
  setSelectedValues,
  setIsEditMode,
  categorieFields,
}) => {
  const [bannerImage, setBannerImage] = useState(null);
  const [video, setVideo] = useState(null);
  const [images, setImages] = useState([]);
  console.log("Filtered Values:", selectedValues);

  const dispatch = useDispatch();
  const locations = useSelector((state) => state.VendorManagementR.AllLoc);
  useEffect(() => {
    dispatch(ShowAllServiceLocation());
  }, [dispatch]);

  useEffect(() => {
    if (
      selectedValues.BannerImage &&
      typeof selectedValues.BannerImage === "string"
    ) {
      const parsedBannerImage = JSON.parse(selectedValues.BannerImage);
      if (parsedBannerImage?.length > 0) {
        setBannerImage(parsedBannerImage[0]?.path);
      }
    }
    if (selectedValues.Image && typeof selectedValues.Image === "string") {
      const parsedImages = JSON.parse(selectedValues.Image);
      setImages(parsedImages.map((img) => img.path));
    }
    if (selectedValues.Video && typeof selectedValues.Video === "string") {
      const parsedVideo = JSON.parse(selectedValues.Video);
      if (parsedVideo?.length > 0) {
        setVideo(parsedVideo[0]?.path);
      }
    }
  }, [selectedValues]);

  const handleFileChange = (e, type) => {
    const files = Array.from(e.target.files);

    if (type === "banner") {
      setBannerImage(files[0]);
    } else if (type === "video") {
      console.log(files[0]);
      setVideo(files[0]);
    } else {
      if (images.length + files.length > 9) {
        alert("You can upload a maximum of 9 images.");
        return;
      }
      setImages((prev) => [...prev, ...files]);
    }
  };

  // console.log(video);

  const handleDeleteImage = async (index, vendorId) => {
    try {
      // Send DELETE request with request body
      const response = await axios.request({
        method: "DELETE",
        url: `${BASE_URL}/api/v1/VendorManagement/Delete-Vendor-Service-Files`,
        data: {
          id: Number(selectedValues.id), // Vendor ID
          deleteImageIndexes: [index], // Send index of the image to delete
          deleteBannerImageIndexes: [], // Empty if not deleting banner images
          deleteVideo: false, // Set false unless deleting a video
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Ensure token is included
        },
      });

      if (response.status === 200) {
        // Remove image from state after successful deletion
        setImages((prev) => prev.filter((_, i) => i !== index));
        alert("Image deleted successfully");
      }
    } catch (error) {
      console.error("Error deleting image:", error);
      alert("Failed to delete image. Please try again.");
    }
  };

  const parseDynamicData = (data) => {
    try {
      // Parse the JSON string into an object
      const parsedData = JSON.parse(data);
      // console.log("Parsed Dynamic Data:", parsedData);
      // Iterate through the parsed object to extract keys and values
      // Object.keys(parsedData).forEach((key) => {
      //   console.log(` ${key} : ${parsedData[key]}`);
      // });

      // Return parsed data for use in the component
      return parsedData;
    } catch (error) {
      console.error("Error parsing DynamicData:", error);
      return {}; // Return an empty object in case of error
    }
  };

  const parseFieldValue = (fieldValue, fieldName) => {
    // console.log("Original fieldValue for", fieldName, ":", fieldValue);

    const DynamicData = filteredVendor.DynamicData;
    // console.log("DynamicData for", DynamicData);

    try {
      // Step 1: Always check if DynamicData exists and process it
      let result = fieldValue; // Start with the fieldValue

      if (DynamicData) {
        const parsedDynamicData = parseDynamicData(DynamicData);
        // console.log(
        //   "Parsed dynamic data for",
        //   fieldName,
        //   ":",
        //   parsedDynamicData
        // );

        // Check if the fieldName exists in parsedDynamicData, and return the corresponding value
        if (parsedDynamicData && parsedDynamicData[fieldName]) {
          result = parsedDynamicData[fieldName];
          // console.log(
          //   "Returning DynamicData value for",
          //   fieldName,
          //   ":",
          //   result
          // );
          return result; // If we found the fieldName in DynamicData, return it
        }
      }

      // Step 2: Check if the fieldValue is a valid JSON string (starts with { or [)
      if (
        typeof fieldValue === "string" &&
        (fieldValue.startsWith("{") || fieldValue.startsWith("["))
      ) {
        try {
          // If it's a valid JSON string, parse it
          result = JSON.parse(fieldValue);
          console.log("Parsed JSON value for", fieldName, ":", result);
        } catch (e) {
          console.error("Error parsing JSON for", fieldName, ":", e);
        }
      }

      // Step 3: If it's a plain string (and not JSON or DynamicData), return it as is
      if (
        typeof fieldValue === "string" &&
        !fieldValue.startsWith("{") &&
        !fieldValue.startsWith("[")
      ) {
        // console.log(
        //   "Returning string value as is for",
        //   fieldName,
        //   ":",
        //   fieldValue
        // );
        result = fieldValue; // Return the string as is
      }

      console.log("Final result for", fieldName, ":", result);
      return result;
    } catch (e) {
      console.error("Error processing value for", fieldName, ":", e);
      return fieldValue; // If an error occurs, return original fieldValue
    }
  };

  const handleFieldChange = (name, value) => {
    setSelectedValues((prev) => ({
      ...prev,
      [name]: value,
      DynamicData: {
        ...prev.DynamicData,
        [name]: value,
      },
    }));
  };

  useEffect(() => {
    try {
      // Parse and set Banner Image
      if (
        selectedValues.BannerImage &&
        typeof selectedValues.BannerImage === "string"
      ) {
        const parsedBannerImage = JSON.parse(selectedValues.BannerImage);
        if (parsedBannerImage.length > 0) {
          const imageUrl = `${BASE_URL}${parsedBannerImage[0].path.replace(
            "/home/CEP_BackEnd",
            ""
          )}`;
          setBannerImage(imageUrl);
        }
      }

      // Parse and set Images
      if (selectedValues.Image && typeof selectedValues.Image === "string") {
        const parsedImages = JSON.parse(selectedValues.Image);
        const imageUrls = parsedImages.map(
          (img) => `${BASE_URL}${img.path.replace("/home/CEP_BackEnd", "")}`
        );
        setImages(imageUrls);
      }

      if (selectedValues.Video && typeof selectedValues.Video === "string") {
        const parsedVideo = JSON.parse(selectedValues.Video);
        if (parsedVideo?.path) {
          // Directly access the path
          const videoUrl = `${BASE_URL}${parsedVideo.path.replace(
            "/home/CEP_BackEnd",
            ""
          )}`;
          console.log(videoUrl);
          setVideo(videoUrl);
        }
      }

      // Parse ServiceLocations
      if (
        selectedValues.ServiceLocations &&
        typeof selectedValues.ServiceLocations === "string"
      ) {
        setSelectedValues((prev) => ({
          ...prev,
          ServiceLocations: JSON.parse(selectedValues.ServiceLocations),
        }));
      }

      // Parse SocialMediaHandle
      if (
        selectedValues.SocialMediaHandle &&
        typeof selectedValues.SocialMediaHandle === "string"
      ) {
        setSelectedValues((prev) => ({
          ...prev,
          SocialMediaHandle: JSON.parse(selectedValues.SocialMediaHandle),
        }));
      }

      // Parse DynamicData
      if (
        selectedValues.DynamicData &&
        typeof selectedValues.DynamicData === "string"
      ) {
        setSelectedValues((prev) => ({
          ...prev,
          DynamicData: JSON.parse(selectedValues.DynamicData),
        }));
      }
    } catch (error) {
      console.error("Error parsing data:", error);
    }
  }, [selectedValues]);

  const locationOptions =
    locations?.map((location) => ({
      value: location.LocationName,
      label: location.LocationName,
    })) || [];

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const formData = new FormData();
  //   formData.append("id", selectedValues.id);
  //   // formData.append("OwnerName", selectedValues.OwnerName);
  //   // formData.append("OwnerEmail", selectedValues.OwnerEmail);
  //   // formData.append("BusinessName", selectedValues.BusinessName);
  //   // formData.append("OwnerMobile_number", selectedValues.OwnerMobile_number);
  //   // formData.append("OwnerWhatsapp_number", selectedValues.OwnerWhatsapp_number);
  //   formData.append("ServiceCategory_ID", selectedValues.ServiceCategory_ID);
  //   formData.append("ServiceCategory_Name", selectedValues.ServiceName);
  //   formData.append("ServiceDescription", selectedValues.ServiceDescription);
  //   formData.append(
  //     "ServiceLocations",
  //     JSON.stringify(selectedValues.ServiceLocations)
  //   );
  //   formData.append(
  //     "SocialMediaHandle",
  //     JSON.stringify(selectedValues.SocialMediaHandle)
  //   );
  //   formData.append("Location", selectedValues.Location);
  //   formData.append("City", selectedValues.City);
  //   formData.append("CompanyName", selectedValues.CompanyName);
  //   formData.append("TotalBudget", selectedValues.TotalBudget);
  //   formData.append(
  //     "SpecialBadges",
  //     JSON.stringify(selectedValues.SpecialBadges)
  //   );
  //   formData.append("DynamicData", JSON.stringify(selectedValues.DynamicData));
  //   formData.append("Vendor_ID", selectedValues.Vendor_ID);
  //   formData.append("ServiceName", selectedValues.ServiceName);

  //   // Function to fetch and convert image URLs to binary
  //   const fetchImageAsBlob = async (imageUrl) => {
  //     const response = await fetch(imageUrl);
  //     const blob = await response.blob();

  //     // Extract filename from the URL
  //     const urlParts = imageUrl.split("/");
  //     const fileName = urlParts[urlParts.length - 1]; // Get the last part as filename

  //     return new File([blob], fileName, { type: blob.type });
  //   };

  //   if (bannerImage instanceof File) {
  //     formData.append("BannerImage", bannerImage);
  //   } else if (
  //     typeof bannerImage === "string" &&
  //     bannerImage.startsWith("http")
  //   ) {
  //     const bannerBlob = await fetchImageAsBlob(bannerImage);
  //     formData.append("BannerImage", bannerBlob);
  //   }

  //   if (video instanceof File) {
  //     console.log(video);
  //     formData.append("Video", video);
  //   } else if (typeof video === "string" && video.startsWith("http")) {
  //     const videoBlob = await fetchImageAsBlob(video);
  //     formData.append("Video", videoBlob);
  //   }

  //   for (const image of images) {
  //     if (image instanceof File) {
  //       formData.append("Images", image);
  //     } else if (typeof image === "string" && image.startsWith("http")) {
  //       const imageBlob = await fetchImageAsBlob(image);
  //       formData.append("Images", imageBlob);
  //     }
  //   }

  //   try {
  //     const response = await fetch(
  //       `http://13.201.62.30:5000/api/v1/VendorManagement/Update-Vendor-Service/${selectedValues.id}`,
  //       {
  //         method: "PUT",
  //         body: formData,
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error("Failed to update service details");
  //     }

  //     const data = await response.json();
  //     console.log(formData);
  //     console.log("Update successful:", data);
  //     // window.location.reload();
  //     setIsEditMode(false);
  //   } catch (error) {
  //     console.error("Error updating service:", error);
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("id", selectedValues.id);
    formData.append("ServiceCategory_ID", selectedValues.ServiceCategory_ID);
    formData.append("ServiceCategory_Name", selectedValues.ServiceName);
    formData.append("ServiceDescription", selectedValues.ServiceDescription);
    formData.append(
      "ServiceLocations",
      JSON.stringify(selectedValues.ServiceLocations)
    );
    formData.append(
      "SocialMediaHandle",
      JSON.stringify(selectedValues.SocialMediaHandle)
    );
    formData.append("Location", selectedValues.Location);
    formData.append("City", selectedValues.City);
    formData.append("CompanyName", selectedValues.CompanyName);
    formData.append("TotalBudget", selectedValues.TotalBudget);
    formData.append(
      "SpecialBadges",
      JSON.stringify(selectedValues.SpecialBadges)
    );
    formData.append("DynamicData", JSON.stringify(selectedValues.DynamicData));
    formData.append("Vendor_ID", selectedValues.Vendor_ID);
    formData.append("ServiceName", selectedValues.ServiceName);

    // Append only new banner image if it's a File
    if (bannerImage instanceof File) {
      formData.append("BannerImage", bannerImage);
    }

    // Append only new video if it's a File
    if (video instanceof File) {
      formData.append("Video", video);
    }

    // Append only new images if they are Files
    for (const image of images) {
      if (image instanceof File) {
        formData.append("Images", image);
      }
    }

    try {
      const response = await fetch(
        `
        ${BASE_URL}/api/v1/VendorManagement/Update-Vendor-Service/${selectedValues.id}`,
        {
          method: "PUT",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update service details");
      }

      const data = await response.json();
      console.log("Update successful:", data);
      setIsEditMode(false);
      window.location.reload();
    } catch (error) {
      console.error("Error updating service:", error);
    }
  };
  const handleDeleteBannerImage = async (index) => {
    try {
      const response = await axios.request({
        method: "DELETE",
        url: `${BASE_URL}/api/v1/VendorManagement/Delete-Vendor-Service-Files`,
        data: {
          id: Number(selectedValues.id), // Vendor ID
          deleteImageIndexes: [], // No regular images deleted
          deleteBannerImageIndexes: [index], // Send index of the banner image to delete
          deleteVideo: false, // Not deleting videos
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        setBannerImage(null); // Remove banner from UI
        alert("Banner image deleted successfully");
      }
    } catch (error) {
      console.error("Error deleting banner image:", error);
      alert("Failed to delete banner image. Please try again.");
    }
  };

  const handleDeleteVideo = async () => {
    if (!selectedValues || !selectedValues.id) {
      console.error("Vendor ID is missing!");
      alert("Vendor ID is not available. Please try again.");
      return;
    }

    try {
      const response = await axios.request({
        method: "DELETE",
        url: `${BASE_URL}/api/v1/VendorManagement/Delete-Vendor-Service-Files`,
        data: {
          id: Number(selectedValues.id), // Vendor ID
          deleteImageIndexes: [],
          deleteBannerImageIndexes: [],
          deleteVideo: true, // ✅ Mark video for deletion
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        setVideo(null); // Remove video from UI
        alert("Video deleted successfully");
      }
    } catch (error) {
      console.error("Error deleting video:", error);
      alert("Failed to delete video.");
    }
  };

  return (
    <div
      component="form"
      style={{ display: "flex", flexDirection: "column", gap: "16px" }}
    >
      <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
        <div
          className="Serviceedit-container"
          style={{ display: "flex", gap: "20px", marginBottom: "15px" }}
        >
          <label style={{ flex: 1 }}>
            <strong>Company Name:</strong>
            <input
              type="text"
              disabled
              value={selectedValues.CompanyName || ""}
              onChange={(e) =>
                setSelectedValues((prev) => ({
                  ...prev,
                  CompanyName: e.target.value,
                }))
              }
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "5px",
                boxSizing: "border-box",
              }}
            />
          </label>

          <label style={{ flex: 1 }}>
            <strong>City:</strong>
            <input
              type="text"
              disabled
              value={selectedValues.City || ""}
              onChange={(e) =>
                setSelectedValues((prev) => ({
                  ...prev,
                  City: e.target.value,
                }))
              }
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "5px",
                boxSizing: "border-box",
              }}
            />
          </label>
        </div>

        {/* Row 2: Location */}
        <div style={{ marginBottom: "15px" }}>
          <label>
            <strong>Location:</strong>
            <input
              type="text"
              disabled
              value={selectedValues.Location || ""}
              onChange={(e) =>
                setSelectedValues((prev) => ({
                  ...prev,
                  Location: e.target.value,
                }))
              }
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "5px",
                boxSizing: "border-box",
              }}
            />
          </label>
        </div>

        {/* Row 3: Service Description */}
        <div className="mb-2">
          <label>
            <p>
              <strong>Description:</strong>
            </p>
            <TextField
              label="Description"
              multiline
              rows={4}
              fullWidth // Ensures it spans the full width of the parent container
              value={selectedValues.ServiceDescription || ""}
              onChange={(e) =>
                setSelectedValues((prev) => ({
                  ...prev,
                  ServiceDescription: e.target.value,
                }))
              }
              variant="outlined" // Other options: filled, standard
              sx={{
                width: { xs: "200px", sm: "450px", md: "700px" }, // Responsive width
                marginTop: "10px",
              }}
            />
          </label>
        </div>
        <div>
          <label style={{ flex: 1 }}>
            <strong>Category name:</strong>
            <input
              type="text"
              value={selectedValues.ServiceName || ""}
              onChange={(e) =>
                setSelectedValues((prev) => ({
                  ...prev,
                  City: e.target.value,
                }))
              }
              disabled
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "5px",
                boxSizing: "border-box",
              }}
            />
          </label>
        </div>
        <div>
          <label>
            <strong>Service Locations</strong>
          </label>
          <Select
            isMulti
            name="serviceLocations"
            options={locationOptions} // Dynamically fetched locations
            value={locationOptions.filter((option) =>
              (selectedValues.ServiceLocations || []).includes(option.value)
            )}
            onChange={(selectedOptions) => {
              setSelectedValues((prev) => ({
                ...prev,
                ServiceLocations: selectedOptions.map((opt) => opt.value),
              }));
            }}
            closeMenuOnSelect={false}
            placeholder="Select Service Locations"
            className="basic-multiselect"
            classNamePrefix="select"
          />
        </div>
        <div className="w-100">
          <label className="form-label fw-bold">Social Media Links</label>
          {Array.isArray(selectedValues.SocialMediaHandle) &&
            selectedValues.SocialMediaHandle.map((link, index) => (
              <div
                key={index}
                style={{ display: "flex", gap: "8px", marginBottom: "8px" }}
              >
                <select
                  value={link.platform}
                  onChange={(e) => {
                    const updatedLinks = [...selectedValues.SocialMediaHandle];
                    updatedLinks[index].platform = e.target.value;
                    setSelectedValues({
                      ...selectedValues,
                      SocialMediaHandle: updatedLinks,
                    });
                  }}
                  className="form-select flex-grow-1"
                  style={{ height: "40px", width: "90px" }}
                >
                  <option value="">Select Platform</option>
                  <option value="instagram">Instagram</option>
                  <option value="facebook">Facebook</option>
                  <option value="twitter">Twitter</option>
                </select>
                <input
                  type="text"
                  placeholder="Enter URL"
                  value={link.url}
                  onChange={(e) => {
                    const updatedLinks = [...selectedValues.SocialMediaHandle];
                    updatedLinks[index].url = e.target.value;
                    setSelectedValues({
                      ...selectedValues,
                      SocialMediaHandle: updatedLinks,
                    });
                  }}
                  className="form-control flex-grow-1"
                  style={{ height: "40px" }}
                />
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ height: "40px", padding: "5px 10px" }}
                  onClick={() =>
                    setSelectedValues({
                      ...selectedValues,
                      SocialMediaHandle: [
                        ...selectedValues.SocialMediaHandle,
                        { platform: "", url: "" },
                      ],
                    })
                  }
                >
                  Add
                </button>
                {selectedValues.SocialMediaHandle.length > 1 && (
                  <button
                    type="button"
                    className="btn btn-danger"
                    style={{ height: "40px", padding: "5px 10px" }}
                    onClick={() =>
                      setSelectedValues({
                        ...selectedValues,
                        SocialMediaHandle:
                          selectedValues.SocialMediaHandle.filter(
                            (_, idx) => idx !== index
                          ),
                      })
                    }
                  >
                    Remove
                  </button>
                )}
              </div>
            ))}
        </div>
        <div style={{ flex: "1 1 100%" }}>
          <label>Banner Image</label>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {bannerImage && (
              <div style={{ position: "relative", width: "102px" }}>
                <img
                  src={(() => {
                    try {
                      console.log("Raw bannerImage data:", bannerImage);

                      // ✅ Handle full URL case
                      if (
                        typeof bannerImage === "string" &&
                        bannerImage.startsWith("http")
                      ) {
                        console.log(
                          "BannerImage is already a URL:",
                          bannerImage
                        );
                        return bannerImage
                          .replace("/home/CEP_BackEnd", "")
                          .replace("/home/ubuntu/new/CEP_BackEnd", "");
                      }

                      let imageData = [];
                      if (typeof bannerImage === "string") {
                        imageData = JSON.parse(bannerImage);
                      } else if (Array.isArray(bannerImage)) {
                        imageData = bannerImage;
                      }

                      console.log("Parsed bannerImage object:", imageData);

                      // ✅ Extract and clean path from the first banner image
                      if (imageData.length > 0 && imageData[0].path) {
                        const imagePath = `${BASE_URL}${imageData[0].path
                          .replace("/home/CEP_BackEnd", "")
                          .replace(
                            "/home/ubuntu/new/CEP_BackEnd",
                            ""
                          )}`.replace(/([^:])\/\//g, "$1/"); // Fix double slashes

                        console.log("Final banner image path:", imagePath);
                        return imagePath;
                      }

                      // ✅ If it's a File object, create a preview URL
                      if (bannerImage instanceof File) {
                        return URL.createObjectURL(bannerImage);
                      }
                    } catch (error) {
                      console.error("Error parsing bannerImage:", error);
                    }

                    return ""; // Fallback empty string
                  })()}
                  alt="Banner"
                  style={{ width: "100px", height: "100px" }}
                />
                <button
                  type="button"
                  className="btn btn-sm rounded-circle d-flex justify-content-center align-items-center"
                  style={{
                    position: "absolute",
                    top: "5px",
                    right: "5px",
                    width: "25px",
                    height: "25px",
                    fontSize: "14px",
                    lineHeight: "1",
                    padding: "0",
                  }}
                  onClick={() => handleDeleteBannerImage(0)}
                >
                  ❌
                </button>
              </div>
            )}
          </div>
          <input
            type="file"
            className="form-control border rounded mt-2"
            style={{ cursor: "pointer", width: "220px" }}
            onChange={(e) => handleFileChange(e, "banner")}
          />
        </div>

        <div
          style={{
            flex: "1 1 100%",
            display: "flex",
            flexDirection: "column",
            gap: "7px",
          }}
        >
          <label>Images (Max 9)</label>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
            {images.map((image, index) => (
              <div key={index} style={{ position: "relative" }}>
                <img
                  src={(() => {
                    try {
                      // console.log(`Rawimage[${index}]:`, image);

                      // ✅ If the image is already a URL, return it after fixing the path
                      if (
                        typeof image === "string" &&
                        image.startsWith("http")
                      ) {
                        const fixedUrl = image
                          .replace("/home/CEP_BackEnd", "")
                          .replace("/home/ubuntu/new/CEP_BackEnd", "");
                        // console.log(`Image[${index}] is already a URL:`, fixedUrl);
                        return fixedUrl;
                      }

                      // ✅ Parse JSON if the image is a stringified JSON array
                      let imageData;
                      if (typeof image === "string") {
                        try {
                          imageData = JSON.parse(image);
                          // console.log(`Parsed image[${index}] object:`, imageData);
                        } catch (error) {
                          console.error(
                            `Error parsing image[${index}]:`,
                            error
                          );
                          return "assets/dummyProfile.jpg"; // Fallback image
                        }
                      } else {
                        imageData = image;
                      }

                      // ✅ Handle array case and extract first image
                      if (Array.isArray(imageData) && imageData.length > 0) {
                        const imgObj = imageData[0]; // Get the first image object
                        if (imgObj && imgObj.path) {
                          const processedPath = imgObj.path
                            .replace("/home/CEP_BackEnd/", "")
                            .replace("/home/ubuntu/new/CEP_BackEnd/", "");
                          const finalImageUrl =
                            `${BASE_URL}/${processedPath}`.replace(
                              /([^:])\/\//g,
                              "$1/"
                            );

                          // console.log(`Final image[${index}] URL:`, finalImageUrl);
                          return finalImageUrl;
                        }
                      }

                      // ✅ Handle case where imageData is an object with a path field
                      if (
                        imageData &&
                        typeof imageData === "object" &&
                        imageData.path
                      ) {
                        const processedPath = imageData.path
                          .replace("/home/CEP_BackEnd/", "")
                          .replace("/home/ubuntu/new/CEP_BackEnd/", "");
                        const finalImageUrl =
                          `${BASE_URL}/${processedPath}`.replace(
                            /([^:])\/\//g,
                            "$1/"
                          );

                        // console.log(`Final image[${index}] URL:`, finalImageUrl);
                        return finalImageUrl;
                      }

                      // ✅ If it's a File object, create a preview URL
                      if (image instanceof File) {
                        return URL.createObjectURL(image);
                      }
                    } catch (error) {
                      console.error(`Error processing image[${index}]:`, error);
                    }

                    return "assets/dummyProfile.jpg"; // Fallback to default image if nothing works
                  })()}
                  alt={`Images ${index + 1}`}
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: "5px",
                  }}
                />

                <button
                  type="button"
                  className="btn btn-sm rounded-circle d-flex justify-content-center align-items-center"
                  style={{
                    position: "absolute",
                    top: "5px",
                    right: "5px",
                    width: "25px",
                    height: "25px",
                    fontSize: "14px",
                    lineHeight: "1",
                    padding: "0",
                  }}
                  onClick={() => handleDeleteImage(index)}
                >
                  ❌
                </button>
              </div>
            ))}
          </div>
          <input
            type="file"
            multiple
            onChange={(e) => handleFileChange(e, "images")}
            className="form-control border rounded "
            style={{ cursor: "pointer", width: "220px" }}
          />
        </div>

        <div style={{ flex: "1 1 100%" }}>
          <label>Video</label>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              position: "relative",
              width: "250px",
            }}
          >
            <video width="250" height="150" controls>
              <source
                src={(() => {
                  try {
                    console.log("Raw video data:", video);

                    // ✅ If `video` is already a URL, return it after fixing the path
                    if (typeof video === "string" && video.startsWith("http")) {
                      const fixedUrl = video
                        .replace("/home/CEP_BackEnd", "")
                        .replace("/home/ubuntu/new/CEP_BackEnd", "");
                      console.log("Video is already a URL:", fixedUrl);
                      return fixedUrl;
                    }

                    // ✅ If `video` is a file path string, return it after cleaning up
                    if (
                      typeof video === "string" &&
                      video.startsWith("/home")
                    ) {
                      const processedPath = video
                        .replace("/home/CEP_BackEnd/", "")
                        .replace("/home/ubuntu/new/CEP_BackEnd/", "");
                      const finalVideoUrl =
                        `${BASE_URL}/${processedPath}`.replace(
                          /([^:])\/\//g,
                          "$1/"
                        );

                      console.log("Final video URL from path:", finalVideoUrl);
                      return finalVideoUrl;
                    }

                    // ✅ Check if `video` is a valid JSON before parsing
                    let videoData;
                    if (
                      typeof video === "string" &&
                      video.includes("{") &&
                      video.includes("}")
                    ) {
                      try {
                        videoData = JSON.parse(video);
                        console.log("Parsed video object:", videoData);
                      } catch (error) {
                        console.error("Error parsing video JSON:", error);
                        return "assets/defaultVideo.mp4"; // Fallback video
                      }
                    } else {
                      videoData = video;
                    }

                    // ✅ Extract path from valid JSON object
                    if (
                      videoData &&
                      typeof videoData === "object" &&
                      videoData.path
                    ) {
                      const processedPath = videoData.path
                        .replace("/home/CEP_BackEnd/", "")
                        .replace("/home/ubuntu/new/CEP_BackEnd/", "");
                      const finalVideoUrl =
                        `${BASE_URL}/${processedPath}`.replace(
                          /([^:])\/\//g,
                          "$1/"
                        );

                      console.log("Final video URL:", finalVideoUrl);
                      return finalVideoUrl;
                    }
                  } catch (error) {
                    console.error("Error processing video:", error);
                  }

                  return "assets/defaultVideo.mp4"; // Fallback video
                })()}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>

            <button
              type="button"
              className="btn btn-sm rounded-circle d-flex justify-content-center align-items-center"
              style={{
                position: "absolute",
                top: "5px",
                right: "5px",
                width: "25px",
                height: "25px",
                fontSize: "14px",
                lineHeight: "1",
                padding: "0",
              }}
              onClick={handleDeleteVideo}
            >
              ❌
            </button>
          </div>
          <input
            type="file"
            className="form-control border rounded "
            style={{ cursor: "pointer", width: "220px" }}
            onChange={(e) => handleFileChange(e, "video")}
          />
        </div>
      </div>
      {/* Dynamic Fields Section */}
      {Array.isArray(categorieFields) &&
        categorieFields.map((field, index) => {
          const fieldValue = selectedValues[field.fieldName] || "";
          const parsedValue = parseFieldValue(fieldValue, field.fieldName);

          return (
            <div
              key={index}
              style={{
                marginBottom: "10px",
              }}
            >
              <label style={{ display: "block", marginBottom: "5px" }}>
                <strong>{field.fieldName}</strong>

                {/* Select Field */}
                {field.fieldType === "select" ? (
                  <select
                    style={{
                      width: "100%",
                      padding: "10px",
                      boxSizing: "border-box",
                    }}
                    value={
                      selectedValues.DynamicData?.[field.fieldName] ||
                      selectedValues[field.fieldName] ||
                      parsedValue
                    }
                    onChange={(e) =>
                      handleFieldChange(field.fieldName, e.target.value)
                    }
                  >
                    {field.options.map((option, idx) => (
                      <option key={idx} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                ) : /* Multi-Select Field */
                field.fieldType === "multiselect" ? (
                  <Select
                    isMulti
                    name={field.fieldName}
                    options={field.options.map((option) => ({
                      value: option,
                      label: option,
                    }))}
                    value={(
                      selectedValues.DynamicData?.[field.fieldName] ||
                      selectedValues[field.fieldName]
                    )?.map((opt) => ({
                      value: opt,
                      label: opt,
                    }))}
                    onChange={(selectedOptions) =>
                      handleFieldChange(
                        field.fieldName,
                        selectedOptions.map((opt) => opt.value)
                      )
                    }
                  />
                ) : /* Text Field */
                field.fieldType === "text" ? (
                  <input
                    type="text"
                    placeholder={`Enter ${field.fieldName}`}
                    style={{
                      width: "100%",
                      padding: "10px",
                      boxSizing: "border-box",
                    }}
                    value={
                      selectedValues.DynamicData?.[field.fieldName] ||
                      selectedValues[field.fieldName] ||
                      parsedValue
                    }
                    onChange={(e) =>
                      handleFieldChange(field.fieldName, e.target.value)
                    }
                  />
                ) : /* Textarea Field */
                field.fieldType === "textarea" ? (
                  <textarea
                    value={
                      selectedValues.DynamicData?.[field.fieldName] ||
                      selectedValues[field.fieldName] ||
                      parsedValue
                    }
                    onChange={(e) =>
                      handleFieldChange(field.fieldName, e.target.value)
                    }
                    style={{
                      width: "100%",
                      padding: "10px",
                      height: "120px",
                      boxSizing: "border-box",
                    }}
                  />
                ) : /* Number Field */
                field.fieldType === "number" ? (
                  <input
                    type="number"
                    placeholder={`Enter ${field.fieldName}`}
                    style={{
                      width: "100%",
                      padding: "10px",
                      boxSizing: "border-box",
                    }}
                    value={
                      selectedValues.DynamicData?.[field.fieldName] ||
                      selectedValues[field.fieldName] ||
                      parsedValue
                    }
                    onChange={(e) =>
                      handleFieldChange(field.fieldName, e.target.value)
                    }
                  />
                ) : null}
              </label>
            </div>
          );
        })}
      {/* Save Details Button */}
      <button
        onClick={handleSubmit}
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        Save Details
      </button>
    </div>
  );
};

export default VendorServicesEditForm;
